import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";

import { useAutoDarkSide } from "../../../hooks/useDarkSide";

import Modal from "../../../components/Modal";
import { Button } from "../../../components/Button";
import ReactJson from 'react-json-view'

export default function ViewJsonDataDialog({ modalHelper }) {
  const navigate = useNavigate();

  const [theme] = useAutoDarkSide();

  const [errors, setErrors] = useState({});
  const [values, setValues] = useState(modalHelper.activeItem);
  const [jsonTheme, setJsonTheme] = useState("bright"/*theme === 'dark' ? "bright" : "bright:inverted"*/);

  useEffect(() => {
    setJsonTheme("bright"/*theme === 'dark' ? "bright" : "bright:inverted"*/);
  }, [theme]);


  return (
    <Modal
        isOpen={modalHelper.isOpen}
        onClose={() => { modalHelper.close() }}
        size={'large'}
        title={modalHelper.activeItem?.title || "JSON Data"}
    >
      <>
        <div className="overflow-y-scroll" style={{maxHeight: "500px"}}>
          <ReactJson src={modalHelper.activeItem?.data}
            theme={jsonTheme}
            collapseStringsAfterLength={40}
            displayObjectSize={false}
            displayDataTypes={false}
            enableClipboard={false} />
        </div>
        <div className="flex justify-end mt-5 sm:mt-6 space-x-2">
          <Button
            variant={Button.variants.secondary}
            className="justify-center"
            disabled={false}
            onClick={() => {
              modalHelper.close();
            }}
          >
            Close
          </Button>
        </div>
      </>
    </Modal>
  );
}